import React, { useState, useRef } from "react";
import injectSheet from "react-jss";
import Icon from "../../assets/icons/Icon";
import classNames from "classnames";
import { globalTheme } from "../../styles/globalTheme";
import useClickPreventionOnDoubleClick from "../../utils/CancellableClick/useClickPreventionOnDoubleClick";

const Multibutton = ({
  classes,
  disabled,
  disabledOpen,
  name,
  onClick,
  type,
  buttonNames,
  secondClick,
  //forwardButton2Style,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  //const [isDisabled, setDisabled] = useState(disabled);
  const button = useRef();

  const FirstButtonClick = (e) => {
    //setDisabled(true);
    e.currentTarget = button.current;

    onClick(e);

    //setDisabled(false);
  };
  const [handleClick, handleDoubleClick] = useClickPreventionOnDoubleClick(
    FirstButtonClick,
    FirstButtonClick //() => {}
  );

  const MainButton = (
    <button
      ref={button}
      type={type ? type : "button"}
      disabled={disabled === true ? true : false}
      className={classes.forwardButton1}
      style={
        isOpen
          ? { borderRadius: "4px 0 0 0" }
          : {
              borderRadius: "4px 0 0 4px",
            }
      }
      name={name ? name : ""}
      onClick={disabled === true ? () => {} : handleClick}
      onDoubleClick={disabled === true ? () => {} : handleDoubleClick}
    >
      {buttonNames[0]}
    </button>
  );

  return (
    <div>
      <div className={classes.buttonContainer}>
        {MainButton}
        <div className={classes.splitter} />
        <button
          disabled={disabledOpen === true ? true : false}
          className={classNames(classes.forwardButton2)}
          onClick={() => setIsOpen(!isOpen)}
          style={
            isOpen
              ? { borderRadius: "0 4px 0 0", width: "auto" }
              : { borderRadius: "0 4px 4px 0", width: "auto" }
          }
        >
          <Icon
            type="arrow"
            rotate={isOpen ? 90 : 270}
            width="24px"
            disabled={disabledOpen === true ? true : false}
            disabledColor="#8f919d"
            fill="white"
          />
        </button>
      </div>
      {!isOpen ? null : (
        <button
          onClick={() => {
            secondClick();
            setIsOpen(!isOpen);
          }}
          name={name}
          className={classes.theManInTheBox}
          style={{ width: button.current.offsetWidth + 39 + "px" }}
        >
          {buttonNames[1]}
        </button>
      )}
    </div>
  );
};

const styles = {
  buttonContainer: {
    display: "flex",
    alignItems: "center",
  },
  forwardButton1: {
    padding: "7px",
    backgroundColor: "#335cda",
    border: 0,
    fontSize: "16px",
    minWidth: (props) => (props.minWidth ? props.minWidth : "139px"),
    color: "#fff",
    "&:hover": {
      backgroundColor: "#182d58",
    },
    "&:focus": {
      outline: globalTheme.outline,
    },
  },
  theManInTheBox: {
    padding: "7px",
    backgroundColor: "#335cda",
    border: 0,
    borderTop: "1px solid white",
    borderRadius: "0 0 4px 4px",
    zIndex: 1000,
    fontSize: "16px",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#182d58",
    },
  },
  splitter: {
    width: "1px",
    backgroundColor: "#ffffff",
  },
  forwardButton2: {
    padding: "6.8px",
    backgroundColor: "#335cda",
    border: 0,
    fontSize: "16px",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#182d58",
    },
    "&:focus": {
      outline: globalTheme.outline,
    },
  },
  "@media (max-width: 1023px)": {
    forwardButton1: {
      cursor: "none",
      minWidth: null,
      "&:hover": {
        background: "#335cda",
      },
    },
    buttonContainer: {
      justifyContent: "center",
    },
  },
};
export default injectSheet(styles)(Multibutton);
